import styles from './FeaturedNewsThumbnail.module.scss';
import { FeaturedArticle } from '@/lib/types/api/home-data';
import Link from 'next/link';
import ITSImage from '../ITSImage/ITSImage';
export interface FeaturedNewsThumbnailProps {
  newsItem: FeaturedArticle;
}

export default function FeaturedNewsThumbnail(props: FeaturedNewsThumbnailProps) {
  const { newsItem } = props
  const { image, story_title, source_url, source_title, story_url} = newsItem;

  const featuredNewsThumbnailSizes = `
    (min-width: 1440px) 177px,
    (min-width: 768px) 13.6vw,
    calc((100vw - 56px)/4)
  `;

  return (
    <div className={styles.featured_news_thumbnail_wrapper}>
      <Link
        href={story_url}
        >
        <ITSImage
          src={image}
          alt={story_title}
          width={215}
          height={120}
          srcSetSizes={[[140, 79], [250,141], [400, 225], [640, 361]]}
          sizes={featuredNewsThumbnailSizes}
          className={styles.featured_news_thumbnail_image}
        />
      </Link>
      <div className={styles.featured_news_thumbnail_description}>
        <Link className={styles.featured_news_thumbnail_description_source_link} href={source_url} >
          <span className={styles.featured_news_thumbnail_description_source}>
            {source_title}
          </span>
        </Link>
        <Link href={story_url} >
          <span className={styles.featured_news_thumbnail_description_story}>
            {story_title}
          </span>
        </Link>
      </div>
    </div>
  )
}
